/**
 * Each PageType represents a different path in the application.
 * In some instances, like the admin, the path may run on different applications.
 */
export enum PageTypes {
  HOME = 'home',
  VIEWER = 'viewer',
  REPORTER = 'reporter',
  WORKLIST = 'worklist',
  PATIENT_JACKET = 'patient-jacket',
  AI_SANDBOX = 'ai-sandbox',
  LOGIN = 'login',
  ADMIN = 'admin',
  UNKNOWN = 'unknown',
}
